import { loadStripe } from "@stripe/stripe-js"

export const useStripe = (accountId?: string | null | undefined) => {
  if (accountId) {
    return loadStripe(window.APP_CONFIG.STRIPE_PUBLISHABLE_KEY, { stripeAccount: accountId })
  } else {
    return loadStripe(window.APP_CONFIG.STRIPE_PUBLISHABLE_KEY)
  }
}
